import moment from "moment";
import { api_instance_auth } from ".";

export const uploadPricingFileAPI = async (body) => {
  const response = await api_instance_auth.post("/upload-pricing-file", body);
  return response;
};

export const fetchPricingFileAPI = async ({
  page,
  limit,
  order,
  search,
  rangeStart,
  rangeEnd,
  petro
}) => {
  const start =
    moment(rangeStart).format("YYYY-MM-DD") === "Invalid date"
      ? ""
      : moment(rangeStart).format("YYYY-MM-DD");
  const end =
    moment(rangeEnd).format("YYYY-MM-DD") === "Invalid date"
      ? ""
      : moment(rangeEnd).format("YYYY-MM-DD");
  const response = await api_instance_auth.get(
    `/get-pricing-files?page=${page}&limit=${limit}&order=${order}&search=${search}&rangeStart=${start}&rangeEnd=${end}&station=${petro}`
  );
  return response;
};

export const deletePricingFileAPI = async (id) => {
  const response = await api_instance_auth.post(`/delete-pricing-file`, {
    ids: [id],
  });
  return response;
};

export const fileIsExistOrNot = async (body) => {
  const response = await api_instance_auth.post(`/check-file-exists`, body);
  return response;
};
